var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"banner",style:({ backgroundImage: ("url(" + (_vm.baseInfo.banner) + ")") })}),_c('router-view'),_c('BottomTabBar',{attrs:{"tabs":_vm.tabs,"themeColor":_vm.themeColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }